// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","HasSeen":"cn_a bhk_fk bhk_vt bhk_xe bhk_h"};